import React from 'react'
import { Checkbox, CheckboxField } from '@/Components/Form/Checkbox'
import { PrimaryButton } from '@/Components/Button'
import TextInput from '@/Components/Form/TextInput'
import { Head, Link, useForm } from '@inertiajs/react'
import { ErrorMessage, Field, FieldGroup, Label } from '@/Components/Form/Fieldset'
import GuestLayout from '@/Layouts/GuestLayout'

export default function Login({ status, canResetPassword }: { status?: string; canResetPassword: boolean }) {
    const { data, setData, post, processing, errors, reset } = useForm<{ email: string; password: string; remember: boolean }>({
        email: '',
        password: '',
        remember: false,
    })

    const submit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault()

        post(route('login'), {
            onFinish: () => reset('password'),
        })
    }

    return (
        <>
            <Head title="Log in" />

            {status && <div className="mb-4 text-sm font-medium text-green-600">{status}</div>}

            <form onSubmit={submit}>
                <FieldGroup>
                    <Field>
                        <Label htmlFor="email" value="Email" />

                        <TextInput
                            id="email"
                            type="email"
                            name="email"
                            value={data.email}
                            className="block w-full"
                            autoComplete="username"
                            isFocused={true}
                            onChange={(e) => setData('email', e.target.value)}
                        />

                        <ErrorMessage message={errors.email} />
                    </Field>

                    <Field>
                        <Label htmlFor="password" value="Passwort" />

                        <TextInput
                            id="password"
                            type="password"
                            name="password"
                            value={data.password}
                            className="block w-full"
                            autoComplete="current-password"
                            onChange={(e) => setData('password', e.target.value)}
                        />

                        <ErrorMessage message={errors.password} />
                    </Field>

                    <CheckboxField className="block">
                        <Checkbox name="remember" checked={data.remember} onChange={(checked: boolean) => setData('remember', checked)} />
                        <Label headlessUi={true}>An mich erinnern</Label>
                    </CheckboxField>
                </FieldGroup>

                <div className="mt-4 flex items-center justify-end">
                    {canResetPassword && (
                        <Link
                            href={route('password.request')}
                            className="rounded-md text-sm text-gray-600 underline hover:text-gray-900 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
                        >
                            Passwort vergessen?
                        </Link>
                    )}

                    <PrimaryButton className="ms-4" disabled={processing}>
                        Einloggen
                    </PrimaryButton>
                </div>
            </form>
        </>
    )
}

Login.layout = (page: React.ReactElement) => <GuestLayout children={page} />
